import { runEditProgramRequestFlow } from '../shared/runEditProgramRequestFlow';
import { toEditConsolidateRequest } from './consolidateProgramsModel';
import { programRequestsApi } from '../api/programRequestsApi';

export const editConsolidateProgramsFlow = ({
    form,
    details,
    onError,
    api = programRequestsApi,
}) =>
    runEditProgramRequestFlow({
        request: toEditConsolidateRequest(form, details),
        onError,
        updateRequest: api.updateConsolidateRequest,
    });
